import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import isMobile from "ismobilejs";

const telefono = tipo => (value, campos) => {
	const numero = (value != undefined)? value.replace("+","").replace(" ","") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";

	if(numero != "") {
		campos[tipo] = prefijo + numero;
	} else {
		campos[tipo] = "";
	}
	
	if(numero != "" && isNaN(numero)) {
		let _temp = "";
		for(let i = 0; i < numero.length; i++) { 
			if(!isNaN(numero.substr(i,1))) {
				_temp  +=  numero.substr(i,1);
			}
		}
	}
};

const validate = (campos) => {
	const errors = {};

	if(!campos.lada || !campos.telefono){
		errors.lada = "Campo requerido.";
	} else if((campos.lada.length + campos.telefono.length) !== 10) {
		errors.lada = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}
	
	return errors;
};

const campo = ({ input, type, max, meta: { touched, error } }) => {
	return (
		<div>
			<input {...input} type={type} maxLength={max} />
			{touched && (error && 
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class InconvenientesForm extends React.Component {

	componentWillMount = () => {

		this.props.change("tipo", "fijo");
	}
	
	aceptar = (_llamar) => {
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, llamar: _llamar }))();
	}



	render () {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="datos-wrap">
					<h3 className="text-center" style={{"marginTop":"20px"}}>Inconvenientes en tu registro</h3>
					<div className="row">
						<div className="col-xs-12">
							<div className="texto-12 gray-text mt-10">
								<p>
									Para poder procesar tu solicitud de registro, completa el siguiente formulario.
								</p>
								<p>
									Se realizará la validación de tus datos y si la solicitud es aprobada, te haremos llegar un enlace 
									vía correo electrónico para que concluyas tu registro.<br />
									En caso de requerir más información nos comunicamos contigo.
								</p>
							</div>
						</div>
					</div>
					<div className="row mt-20">
						<div className="col-xs-8">
							<div className="input-wrap no-margin">
								<label>Tipo de teléfono</label>
								<span className="clearfix select-active">
									<Field name="tipo" component="select" className="col-xs-1">
										<option value="fijo">Fijo</option>
										<option value="celular">Celular</option>
									</Field>
								</span>
							</div>
						</div>
						<div className="col-xs-4">
							<div className="input-wrap">
								<label>Extensión</label>
								<span className="clearfix input-inactive">
									<Field name="extension" component={campo} type="text" max="5" />
								</span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-4">
							<div className="input-wrap input-error-doble">
								<label>Lada</label>
								<span className="clearfix input-active">
									<Field name="lada" component={campo} type="text" max="4" />
								</span>
							</div>
						</div>
						<div className="col-xs-8">
							<div className="input-wrap">
								<label>Teléfono</label>
								<span className="clearfix input-active">
									<Field name="telefono" component={campo} type="text" max="8" />
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="datos-wrap">
					<div className="row btn-bottom">
						<div className="col-xs-12">
							<button type="button" onClick={this.aceptar.bind(this, false)} className="orange-rectangle disabled" style={{"marginBottom":"10px"}}>Aceptar</button>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

InconvenientesForm = reduxForm({form: "registro-asistido-inconvenientes", validate})(InconvenientesForm);

export default InconvenientesForm;



// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/inconvenientes.frm.js